/**
 * @file AppContainer/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */
export const TYPE_DETAIL = "detail";

export const META_HEADER_PATH = "meta/global/header";
export const META_FOOTER_PATH = "meta/global/footer";
export const APP_STATUS_PATH = "healthz";
